
import { css } from 'lit';
export default css`
.automatic-grid {
  width: 100%;
}

.automatic-grid__eyebrow {
  margin-bottom: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(117, 118, 119, var(--tw-text-opacity));
}

.automatic-grid__list {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1.5rem;
}

@media (min-width: 768px) {

  .automatic-grid__list {
    row-gap: 3rem;
  }
}

@media (min-width: 640px) {

  .automatic-grid__list.automatic-2-columns-grid__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 640px) {

  .automatic-grid__list.automatic-3-columns-grid__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .automatic-grid__list.automatic-3-columns-grid__list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 640px) {

  .automatic-grid__list.automatic-4-columns-grid__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .automatic-grid__list.automatic-4-columns-grid__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {

  .automatic-grid__list.automatic-4-columns-grid__list {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.automatic-grid--icon-card .automatic-grid__eyebrow {
  margin-bottom: 4rem;
}

.automatic-grid--icon-card .automatic-grid__list {
  row-gap: 5rem;
}

.automatic-grid--icon-card .automatic-grid__list {
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
}

@media (min-width: 768px) {

  .automatic-grid--icon-card .automatic-grid__list {
      -moz-column-gap: 2.5rem;
           column-gap: 2.5rem;
  }
}

.automatic-grid--search-panel .automatic-grid__list {
    gap: 36px;
  }

@media (min-width: 1024px) {

  .automatic-grid--search-panel .automatic-grid__list {
    gap: 1.5rem;
  }
}

.automatic-grid--location-card-grid .automatic-grid__list {
    gap: 2.625rem;
    row-gap: 2.5rem;
  }
`;